module.exports = __webpack_public_path__ + "img/image-5.137156d7.jpg";